import type { BuiltInCodePage } from '@trinity/custom-pages-registry-types';
import { FRMAccountInsights, FRMPolicySearch, FRMTerritoryInsights } from './FRM/index.js';
import { MslTerritoryInsights } from './MSL/index.js';
import { TestCustomPage } from './Test.js';

type Props = {
  codePage: BuiltInCodePage;
};

export function CustomCodePageRenderer({ codePage }: Props): React.ReactElement {
  switch (codePage) {
    case 'frm-account-insights':
      return <FRMAccountInsights />;
    case 'frm-policy-search':
      return <FRMPolicySearch />;
    case 'frm-territory-insights':
      return <FRMTerritoryInsights />;
    case 'msl-territory-insights':
      return <MslTerritoryInsights />;
    case 'test':
      return <TestCustomPage />;

    default:
      return <>This code page is not available yet.</>;
  }
}
